import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { GROUPABLE_ACTIVE, TEAM, TEAM_LEAD } from 'modules/approvals/lib/roles'
import teams from 'modules/teams/store/collections/teams'

interface Props {
  selectedMember?: string
  setSelectedTeam: (team_id: string) => void
  selectedTeam?: string | null
}

const TeamSelector = ({ selectedTeam, setSelectedTeam, selectedMember }: Props) => {
  const groupable = [TEAM, TEAM_LEAD, GROUPABLE_ACTIVE].includes(selectedMember?.toString() ?? '')
  return (
    <>
      {groupable && (
        <SelectField
          label={i18n.t('settings.approvals.approval_level.team')}
          value={selectedTeam?.toString()}
          onChange={(team_id) => setSelectedTeam(team_id)}
          options={teams.map((team) => ({
            value: team.attributes.id,
            label: team.attributes.name,
          }))}
        />
      )}
    </>
  )
}

export default TeamSelector
